<script lang="ts">
  import App from "../App.svelte";
  import type { AppFixture } from "../model";

  let { fixture, onFixtureChange }: { fixture?: AppFixture; onFixtureChange?: (patch: Partial<AppFixture>) => void } = $props();
</script>

<div class="production-app-host">
  <App {fixture} {onFixtureChange} />
</div>

<style>
  .production-app-host { font-family:"Figtree",sans-serif; min-height:100%; width:100%; }
</style>
